import * as React from 'react';
import './employee-modal.scss';

// Assets
import { ReactComponent as Close } from '../../../assets/images/close.svg';
import { ReactComponent as ProfileIcon } from '../../../assets/icons/profile_small.svg';
import { ReactComponent as TaskTickIcon } from '../../../assets/icons/icon_task_tick.svg';
import { ReactComponent as EllipseIcon } from '../../../assets/icons/ellipse.svg';
import { ReactComponent as AttachmentIcon } from '../../../assets/icons/icon_attach.svg';
import { ReactComponent as MessageIcon } from '../../../assets/icons/icon_message.svg';
import { ReactComponent as TaskTickAbnormalIcon } from '../../../assets/icons/task_tick_icon.svg';

// Data
import employeeList from '../employee-list.json';

interface Props {
    onClose: Function;
    employeeId?: string;
}

const EmployeeModal: React.FC<Props> = ({ onClose, employeeId }) => {
    const [employee, setEmployee] = React.useState<any>();

    const onCloseModal = () => {
        onClose(false);
    };

    React.useEffect(() => {
        const employee = employeeList.filter((data: any) => data.id === employeeId)[0];
        setEmployee(employee);
    }, []);

    return (
        <>
            <div className="employee-modal-outer">
                <div className="employee-modal">
                    <div className="employee-modal__modal-action">
                        <div className="modal-action__close" onClick={onCloseModal}>
                            <Close />
                        </div>
                    </div>
                    <div className="employee-modal__head">
                        <div className="employee-modal__profile-image">
                            <ProfileIcon />
                        </div>
                        <div>
                            <div className="employee-modal__head__text">{employee && employee.name}</div>
                            <div className="employee-modal__head__submit-time">
                                제출시간 | {employee && employee.submissionDate} {employee && employee.submissionTime}
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="employee-modal__checklist">
                            {employee &&
                                employee.checklist.map((item: any) => (
                                    <div className="employee-modal__checklist__item">
                                        <div className="employee-modal__checklist__item__item">
                                            <EllipseIcon />
                                            <span className="employee-modal__checklist__item__item__text">
                                                {item.item}
                                            </span>
                                        </div>
                                        <div className="employee-modal__checklist__item__type">
                                            {item.isNormal ? <TaskTickIcon /> : <TaskTickAbnormalIcon />}
                                            <span
                                                className={
                                                    item.isNormal
                                                        ? 'employee-modal__checklist__item__type__text'
                                                        : 'employee-modal__checklist__item__type__text-abnormal'
                                                }
                                            >
                                                {item.type}
                                            </span>
                                        </div>
                                    </div>
                                ))}
                        </div>
                        <div className="employee-modal__checklist__attachments">
                            <div className="employee-modal__checklist__attachments__head">
                                <AttachmentIcon />
                                <span className="employee-modal__checklist__attachments__head-text">사진 첨부</span>
                            </div>
                            <div className="employee-modal__checklist__attachments__body">
                                {employee &&
                                    employee.attachments.map((attachment: string) => (
                                        <div className='employee-modal__className="checklist__attachments__images'>
                                            <img
                                                className="employee-modal__checklist__attachments__image"
                                                src={attachment}
                                                alt="attachment"
                                            />
                                        </div>
                                    ))}
                            </div>
                        </div>
                        <div className="employee-modal__checklist__memo">
                            <div className="employee-modal__checklist__memo__head">
                                <MessageIcon />
                                <span className="employee-modal__checklist__memo__head-text">메모</span>
                            </div>
                            <div className="employee-modal__checklist__memo__body">{employee && employee.memo}</div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default EmployeeModal;
